import { Component, computed, inject, OnInit, Signal } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DatePipe } from '@angular/common';
import { Pack } from 'src/app/interfaces/pack';
import { iUser } from 'src/app/interfaces/user';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { PackService } from 'src/app/services/pack.service';

@Component({
  selector: 'app-pack-overview',
  templateUrl: './pack-overview.component.html',
  styleUrls: ['./pack-overview.component.scss'],
  standalone: true,
  imports: [
    IonicModule,
    DatePipe
  ]
})
export class PackOverviewComponent implements OnInit {

  public packService = inject(PackService)
  public auth = inject(AuthenticationService)

  public currentPacks: Signal<Pack[]> = computed(() => this.packService.currentPacks());
  public user: Signal<iUser> = computed(() => this.auth.user());


  ngOnInit(): void {
    this.packService.loadAllUsersPacks();
  }

}
